import { env } from "../config/env";
import { createClient } from "./http";

const api = createClient(env.WAREHOUSE_BASE_URL || env.WAREHOUSE_INVENTORY_BASE_URL || env.REPORT_BASE_URL);

function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
}

export const orderAnalyticsService = {
  async listOrders({
    warehouseId = "",
    status = "",
    paymentStatus = "",
    fromDate = "",
    toDate = "",
    q = "",
    page = 1,
    limit = 10,
  } = {}) {
    return api.get("/api/admin/order-analytics/orders", {
      params: cleanParams({ warehouseId, status, paymentStatus, fromDate, toDate, q, page, limit }),
    });
  },

  async getSummary({
    warehouseId = "",
    status = "",
    paymentStatus = "PAID",
    fromDate = "",
    toDate = "",
  } = {}) {
    return api.get("/api/admin/order-analytics/summary", {
      params: cleanParams({ warehouseId, status, paymentStatus, fromDate, toDate }),
    });
  },

  async getSalesTrend({
    warehouseId = "",
    status = "",
    paymentStatus = "PAID",
    fromDate = "",
    toDate = "",
    period = "day",
  } = {}) {
    return api.get("/api/admin/order-analytics/sales-trend", {
      params: cleanParams({ warehouseId, status, paymentStatus, fromDate, toDate, period }),
    });
  },

  async getProducts({
    warehouseId = "",
    status = "",
    paymentStatus = "PAID",
    fromDate = "",
    toDate = "",
    type = "top",
    limit = 5,
  } = {}) {
    return api.get("/api/admin/order-analytics/products", {
      params: cleanParams({ warehouseId, status, paymentStatus, fromDate, toDate, type, limit }),
    });
  },
};
